import { Currency } from '@/types';
import { fetchFromApi } from './fetchFromApi';

export const fetchCurrency = (currencyId: string) =>
  fetchFromApi<Currency>(`currencies/${currencyId}`);
